import {
    MOVIES_BOX_OFFICE_SUCCEEDED,
    MOVIES_BOX_OFFICE_FAILED,
    MOVIES_BOX_OFFICE_SUCCEEDED_HOME,
    REQUEST_DATES_SUCCEEDED,
    REQUEST_DATES_FAILED,
    BOX_OFFICE_DISTRIBUTORS,
    BOX_OFFICE_DISTRIBUTORS_SUCCEEDED,
    BOX_OFFICE_STUDIOS_SUCCEEDED
} from '../actions/types';

const initialState = {
    errors: {},
    moviesBoxOffice: [],
    boxOfficeHome: [],
    boxOfficeDistributors: [],
    boxOfficeStudios: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case MOVIES_BOX_OFFICE_SUCCEEDED:
            return {
                ...state,
                moviesBoxOffice: action.payload,
            };
        case MOVIES_BOX_OFFICE_SUCCEEDED_HOME:
            return {
                ...state,
                boxOfficeHome: action.payload,
            };

        case MOVIES_BOX_OFFICE_FAILED:
            return {
                errors: {
                    ...action.payload
                }
            };
        case REQUEST_DATES_SUCCEEDED:
            return {
                ...state,
                ...action.payload
            };

        case REQUEST_DATES_FAILED:
            return {
                errors: {
                    ...action.payload
                }
            };

        case BOX_OFFICE_DISTRIBUTORS_SUCCEEDED:
            return {
                ...state,
                boxOfficeDistributors: action.payload
            };

        case BOX_OFFICE_STUDIOS_SUCCEEDED:
            return {
                ...state,
                boxOfficeStudios: action.payload
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/SHARED/reducers/boxoffice.reducer.js